import type { OutpatientClinicEmployment } from '@common/contexts/support/domain/models/outpatientClinicEmploymentModel';
import type { OutpatientClinicEpisodeCategory } from '@common/contexts/support/domain/models/outpatientClinicEpisodeCategoryModel';
import type { OutpatientClinicPractitioner } from '@common/contexts/support/domain/models/outpatientClinicPractitionerModel';
import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';
import { fetchJson } from '@frontend/store/fetch';

export type OutpatientClinicTasksAvailablePerformer = {
    employments: {
        availableForTasks: {
            episodeCategoryId: OutpatientClinicEpisodeCategory['id'];
            id: OutpatientClinicTask['id'];
        };
        id: OutpatientClinicEmployment['id'];
        organizationId: OutpatientClinicEmployment['organization']['id'];
        profession: OutpatientClinicEmployment['profession'];
    }[];
    id: OutpatientClinicPractitioner['id'];
    nameFamily: OutpatientClinicPractitioner['nameFamily'];
    nameGiven: OutpatientClinicPractitioner['nameGiven'];
    nameInfix: OutpatientClinicPractitioner['nameInfix'];
};

type FetchOutpatientClinicTasksAvailablePerformersOptions = {
    abortSignal: AbortSignal;
    taskId: string | string[];
};

export async function fetchOutpatientClinicTasksAvailablePerformers({
    abortSignal,
    taskId,
}: FetchOutpatientClinicTasksAvailablePerformersOptions): Promise<OutpatientClinicTasksAvailablePerformer[]> {
    const taskIds = Array.isArray(taskId) ? taskId : [taskId];
    const tasks = taskIds.map((id) => ({
        id,
    }));

    const response = await fetchJson({
        body: {
            tasks,
        },
        method: 'POST',
        signal: abortSignal,
        url: '/api/outpatientClinic/tasks/availablePerformers',
    });

    if (!response?.json?.practitioners) {
        throw new Error('Failed to fetch available performers');
    }

    return response.json.practitioners;
}
